export const APPS = [
  {
    name: 'Bankline',
    text: 'Visualise and organise NatWest business balances and transactions in one place',
    logo: '',
    url: '',
    isVisible: false
  },
  {
    name: 'Freeagent',
    text: 'Connect FreeAgent accounting for invoicing and forecasting',
    logo: '',
    url: '',
    isVisible: false
  },
  {
    name: 'Freeagent - Codat',
    text: 'Connect FreeAgent accounting for invoicing and forecasting',
    logo: '',
    url: '',
    isVisible: false
  },
  {
    name: 'Sage',
    text: 'Connect Sage accounting for invoicing and forecasting',
    logo: '',
    url: '',
    isVisible: false
  },
  {
    name: 'Xero',
    text: 'Connect Xero accounting for invoicing and forecasting',
    logo: '',
    url: '',
    isVisible: false
  },
  {
    name: 'ClearSpend',
    text: 'Living Commercial Cards customers control of their credit card balances in real-time',
    logo: '',
    url: '',
    isVisible: false
  },
  {
    name: 'Path',
    text: 'Professional help with internal business functions',
    logo: '',
    url: '',
    isVisible: false
  },
];
